import { Textarea } from '@tempo-io/sui-textarea';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '@/components/common/base-dialog/BaseDialog';

interface MultilineEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialValue?: string;
  title: string;
  onSave: (value: string) => void;
}

export const MultilineEditDialog = ({
  open,
  onOpenChange,
  initialValue,
  title,
  onSave,
}: MultilineEditDialogProps) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(initialValue ?? '');

  React.useEffect(() => {
    if (open) setValue(initialValue ?? '');
  }, [open, initialValue]);

  const handleSave = () => {
    onSave(value);
    onOpenChange(false);
  };

  return (
    <BaseDialog
      open={open}
      onOpenChange={onOpenChange}
      showCloseButton
      className="z-1400!"
      title={title}
      primaryAction={{ label: t(($) => $.common.save), onClick: handleSave }}
      secondaryAction={{ label: t(($) => $.common.cancel), onClick: () => onOpenChange(false) }}
    >
      <div className="py-4">
        <Textarea
          className="h-40 w-full"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
      </div>
    </BaseDialog>
  );
};
